import React from 'react';
import { Check } from 'lucide-react';
import type { Language } from '../../i18n/languages';

interface LanguageMenuItemProps {
  language: Language;
  isSelected: boolean;
  isRTL: boolean;
  onSelect: (code: string) => void;
}

const LanguageMenuItem: React.FC<LanguageMenuItemProps> = ({ 
  language, 
  isSelected, 
  isRTL,
  onSelect 
}) => {
  return (
    <div
      onClick={() => onSelect(language.code)}
      className={`
        flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-smooth rounded-md
        ${isSelected ? 'bg-gold/8 hover:bg-gold/12' : 'hover:bg-accent'}
        ${isRTL ? 'flex-row-reverse text-right' : ''}
      `}
    >
      {/* Flag */}
      <div className="text-xl min-w-[24px] text-center">
        {language.flag}
      </div>

      {/* Language Info */}
      <div className={`flex-1 ${isRTL ? 'text-right' : 'text-left'}`}>
        <div className="text-sm font-medium">{language.name}</div>
        <div className="text-xs text-muted-foreground">{language.nativeName}</div>
      </div>

      {/* Check Icon */}
      {isSelected && (
        <div className="min-w-auto">
          <Check className="w-4 h-4 text-gold" />
        </div>
      )}
    </div>
  );
};

export default LanguageMenuItem;

